import Segmented from "components/BaseWidgets/Segmented";
import "./style.scss";

function HeaderSegment({ data, onChange = () => {} ,selectedThread ,}) {


  return (
    <div className={`chat-segment ${selectedThread ? "active" : ""} `}>
      <Segmented onChange={onChange} options={data} />
    </div>
  );
}

export default HeaderSegment;
